<template>
    <div class="container">
        <div class="ban">
            <div class="ban_text">
                <p class="p1">NEWS UPDATES</p>
                <p class="p2">更多新闻动态都在这里</p>
            </div>
        </div>
        <div class="main center">
            <div class="newlist" v-for="(item, index) in newsList" :key="item.id">
                <div class="pic"><img :src="item.pic" alt=""></div>
                <div class="detail">
                    <p class="title">{{ item.title }}</p>
                    <p class="desc">{{ item.introduction }}</p>
                    <div class="last_data">
                        <p style="color:#8c8f99;font-size:12px;">{{ item.create_datetime }}</p>
                        <div @click="toDetailPage(item.id)">查看详情</div>
                    </div>
                </div>
            </div>
            <div class="pagin">
                <el-pagination background layout="prev, pager, next" :total="total" @current-change="handleCurrentChange"
                    :page-size="limit" :current-page="page">
                </el-pagination>
            </div>
        </div>

    </div>
</template>
<script>
import {
    getNewsByType,
    getNewTypeList,
    getNews,
    getuploadImg
} from "@/api/api";
export default {
    data() {
        return {
            newType: [],
            n: 0,
            newsList: [],
            total: 20,
            page: 1,
            limit: 10
        };
    },
    mounted() {
        this.getAllNews()
    },
    methods: {
        handleCurrentChange(val) {
            this.page = val
            this.getAllNews()
        },
        toCurrentType(item) {
            this.n = item.id
            this.getTypeList()
        },
        getNewTypeList() {
            getNewTypeList().then(res => {
                if (res.code === 1000) {
                    this.newType = res.data.data
                    this.n = this.newType[0].id
                    this.getTypeList()
                } else {

                }
            })
        },
        // getTypeList() {
        //     let data = {
        //         type: this.n,
        //         limit: 10,
        //         page: 1,
        //     }
        //     getNewsByType(data).then(res => {
        //         console.log('文章类型--------', res)
        //         this.newsList = res.data.data
        //     })
        // },
        getAllNews() {
            let data = {
                page: this.page,
                limit: this.limit
            }
            getNews(data).then((res) => {
                this.newsList = res.data.data
                this.total = res.data.total
                this.limit = res.data.limit
                this.page = res.data.page
                for (let i = 0; i < this.newsList.length; i++) {
                    // console.log(this.newsList[i].title_avatar)
                    getuploadImg(this.newsList[i].title_avatar).then(res => {
                        this.$set(this.newsList[i], 'pic', res.data.content)
                    })
                }
            })
        },
        toDetailPage(id) {
            this.$router.push({
                name: 'NewDetail',
                query: { id: id }
            })
        },
    }
}
</script>
<style scoped lang="scss">
::v-deep .el-pagination.is-background .el-pager li:not(.disabled) {
    background-color: #FFFFFF; // 进行修改未选中背景和字体
    color: #3D3D3D;
    border-radius: 2px;
    width: 40px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #D8D8D8;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #233B83;
    color: #FFFFFF; //修改选中后的样式
}

//上一页和下一页的样式
::v-deep .el-pagination.is-background .btn-next {
    //margin: 0 5px;
    background-color: #FFFFFF;
    color: #3D3D3D;
    min-width: 40px;
    height: 40px;
    border-radius: 2px;
    border: 1px solid #D8D8D8;
}

::v-deep .el-pagination.is-background .btn-prev {
    //margin: 0 5px;
    background-color: #FFFFFF;
    color: #3D3D3D;
    min-width: 40px;
    height: 40px;
    border-radius: 2px;
    border: 1px solid #D8D8D8;
}

.center {
    width: 57%;
    margin: 0 auto;
}

.ban {
    background: url(../assets/banner_new.png) no-repeat center center;
    background-size: cover;
    height: 430px;
    overflow: hidden;
    // margin-top: 110px;

    .ban_text {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .p1 {
            font-size: 50px;
            font-weight: bold;
            color: #FFFFFF;
        }

        .p2 {
            font-size: 30px;
            color: #FFFFFF;
        }
    }
}

@media screen and (max-width: 750px) {
    .ban {
        height: 346px;
        margin-top: 206px;
    }
}

.main {
    height: auto;
    margin: 100px auto;
    border-top: 1px solid #D8D8D8;

    .newlist {
        // box-shadow: 4px 4px 10px 4px rgba(196, 196, 196, 0.3);
        padding: 47px 0 38px 0;
        border-bottom: 1px solid #D8D8D8;
        display: flex;

        .pic {
            img {
                width: 334px;
                height: 215px;
            }

        }

        .detail {
            text-align: left;
            margin-left: 25px;
            width: 65%;

            .title {
                font-size: 28px;
                font-weight: 500;
                line-height: 60px;
                color: #3D3D3D;
            }

            .desc {
                min-height: 106px;
                font-size: 18px;
                line-height: 36px;
                color: #808080;
                overflow: hidden;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                text-overflow: ellipsis;
            }

            .last_data {
                display: flex;
                justify-content: space-between;

                p {
                    font-size: 18px;
                    line-height: 26px;
                    color: #A4A4A4;
                }

                div {
                    font-size: 18px;
                    line-height: 26px;
                    color: #233B83;
                    padding: 5px 26px;
                    border: 1px solid #233B83;
                    border-radius: 50px;
                    cursor: pointer;
                }
            }


        }


    }

}

@media screen and (max-width: 750px) {
    .center {
        width: 80%;
    }
    .main {
        .newlist {
            width: 100%;

            .pic {
                img {
                    width: 166px;
                    height: 108px;
                }

            }
            .detail {
                width: 80%;
                .last_data{
                    margin-top: 20px;
                }
            }

        }
    }
}

.pagin {
    margin: 50px auto;
}</style>